import { IIdentity } from '.';

export interface GridData extends IIdentity {
  [key: string]: any;
}
